import type { ReactElement } from 'react';
import React, { Fragment } from 'react';
import { DataLayer } from '@alfa-bank/site-data-layer';
import { Link } from '@alfa-bank/site-link';

import type { ILink } from './models';

export const getTextWithLinks = (text: string, links?: ILink[]) => {
    if (links && links.length) {
        const words: Array<ReactElement | string> = text
            .split('#')
            .filter(Boolean)
            .map(word => {
                const wordLink = links.find(link => link.title === word);
                if (wordLink) {
                    const { analytics, href, title } = wordLink;

                    const link = (
                        <Link href={href} kind="caption">
                            {title}
                        </Link>
                    );

                    if (analytics) {
                        return (
                            <DataLayer key={`key-${word}`} data={analytics}>
                                {link}
                            </DataLayer>
                        );
                    }

                    return link;
                }

                return word;
            });

        return (
            <>
                {words.map((el, index) => {
                    const key = `${el}-${index}`;

                    return <Fragment key={key}>{el}</Fragment>;
                })}
            </>
        );
    }

    return <>{text}</>;
};
